import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import styled from "styled-components";
import striptags from "striptags";
import Layout from "../../providers/Layout";
import {
  getLayoutProps,
  getArticleBySlug,
} from "../../services/serverSideRequests";
import {
  fetchApi,
  getArticlesOnList,
  getArticlesById,
} from "../../services/requests";
import { getFullCategoriesData } from "../../services/serverSideRequests";
import { Page, MainContent, Aside } from "../../services/styles";
import { ArticleListBreadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import ArticleFromServices from "../../components/ArticleFromServices/ArticleFromServices";
import ArticleOnListTeaser from "../../components/ArticleOnListTeaser/ArticleOnListTeaser";
import BoxLegalAdvice from "../../components/BoxLegalAdvice/BoxLegalAdvice";
import BoxBuySubscription from "../../components/BoxBuySubscription/BoxBuySubscription";
import BoxNewsletter from "../../components/BoxNewsletter/BoxNewsletter";
import ArticleMetaTags from "../../components/MetaTags/ArticleMetaTags";
import MetaTags from "../../components/MetaTags/MetaTags";
import { device } from "../../services/styles";
import { redirectTo404 } from "../../services/routing";
import Ado from "../../components/Ado/Ado";
import AdoCodes from "../../components/Ado/AdoConfig.json";

const Header = styled.p`
  font-size: 28px;
  line-height: 32px;
  font-weight: 900;
  margin: 40px 0 20px 0;
  text-align: center;

  @media ${device.tablet} {
    margin: 40px 0 20px 0;
    text-align: left;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Article = ({
  navbarLinks,
  submenuLists,
  paths,
  mainCategories,
  importantArticles,
  articleData,
  mainCategory,
  moreArticles,
  featuredArticles,
}) => {
  const article = articleData[0];
  if (!article) {
    return null;
  }
  const { asPath } = useRouter();

  const moreArticlesData = moreArticles
    .map((el) => el[0])
    .filter((el) => el !== null);

  return (
    <>
      <Head>
        <ArticleMetaTags article={article} />
      </Head>
      <Layout
        navbarLinks={navbarLinks}
        paths={paths}
        submenuLists={submenuLists}
        mainCategories={mainCategories}
        importantArticles={importantArticles}
        metatagsData={{
          title: article.title,
          description: striptags(article.lead),
          keywords: article.tags ? article.tags.join(", ") : "",
          href: `${process.env.site}${asPath}`,
          showAuthor: true,
        }}
      >
        <Page>
          <Aside>
            <BoxLegalAdvice />
            <BoxBuySubscription />
            <Ado {...AdoCodes.id04articleSidebar} />
            <BoxNewsletter />
            <Ado {...AdoCodes.id05articleSidebar} />
          </Aside>
          <MainContent>
            <ArticleListBreadcrumbs
              categorySlug={article.category.slug}
              categoryName={article.category.name}
              mainCategory={mainCategory}
              article={article.title}
            />
            <ArticleFromServices article={article} visibleOnload={true} />
            <Ado {...AdoCodes.id02articleUnderArticle} />
            {moreArticlesData.map((article, i) => (
              <div key={`more${article.id}`}>
                {i === 1 && <Ado {...AdoCodes.id03articleUnderComments} />}
                <ArticleFromServices
                  article={article}
                  addShadow={true}
                  visibleOnload={false}
                />
              </div>
            ))}
            {featuredArticles && featuredArticles.length && (
              <Header>Przeczytaj także</Header>
            )}
            <Container>
              {featuredArticles.map(([article]) => (
                <ArticleOnListTeaser
                  key={`featured${article.id}`}
                  article={article}
                />
              ))}
            </Container>
          </MainContent>
        </Page>
      </Layout>
    </>
  );
};

export async function getServerSideProps(context) {
  const layoutProps = await getLayoutProps();
  const articleData = await getArticleBySlug(context.params.article);
  if (articleData[2] && articleData[2].status === 404) {
    redirectTo404(context);
    return;
  }
  const { category, mainCategory } =
    articleData && articleData[0]
      ? await getFullCategoriesData(articleData[0].category.slug)
      : { category: null, mainCategory: null };

  const moreArticles = await getArticlesOnList({
    limit: 3,
  });
  const featuredArticles =
    articleData && articleData[0]
      ? await getArticlesById(articleData[0].featured_articles.slice(0, 3))
      : [];
  return {
    props: {
      articleData,
      category,
      mainCategory,
      featuredArticles,
      ...layoutProps,
      moreArticles,
    },
  };
}
export default Article;
